import React from 'react'
import classNames from 'classnames'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import './index.scss'

const SeeMoreCard = ({ className, onClick = () => {}, disabled, text = '' }) => {
  const t = useTranslate()

  const containerClass = classNames('see-more-video-card', className)

  return (
    <div onClick={onClick} className={containerClass} disabled={disabled}>
      <h5>{text ? text : t(TOLGEE_GLOBALS.seeMore)}</h5>
    </div>
  )
}

export default SeeMoreCard
